module.exports = __webpack_public_path__ + "cmsWeb/suning/o2o/wap/sidesun/images/store_top_default.7bfa077.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_top_default.jpg
// module id = 2eeH
// module chunks = 1